import {ListFilter} from '@shared/base';
import { HttpParams, HttpResponse } from '@angular/common/http';

export type ContentDispositionType = 'inline' | 'attachment';

export class ApiUtils {

  public static createHttpParams(listFilter: ListFilter): HttpParams {
    const filter = new ListFilter();

    const keys = Object.keys(listFilter);
    keys.filter(key => {
      return listFilter[key] && listFilter[key] != null;
    }).forEach(key => {
      filter[key] = listFilter[key];
    });

    return new HttpParams({fromObject: filter});
  }

  public static saveToFileSystem(response: HttpResponse<Blob>, filename?: string): void {
    const headers = response.headers;

    const contentType = headers.get('content-type');
    const blob = new Blob([response.body ?? ''], {type: contentType});
    const downloadURL = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadURL;
    link.download = (filename ?? this.parseContentDispositionHeader(
      headers.get('content-disposition')
    )?.filename) ?? 'file.pdf';
    link.click();
  }

  public static parseContentDispositionHeader(header?: string | null):
    { type: ContentDispositionType, filename?: string } | undefined {

    if (!header) {
      return;
    }

    const [type, filenamePart] = header.split(';');
    let filename: string | undefined = undefined;

    if (filenamePart) {
      [, filename] = filenamePart.trim().split('=');
      filename = filename.replaceAll('"', '');
    }

    return {
      type: type.trim() as ContentDispositionType,
      filename,
    };
  }

  public static trimByChar(origString, charToTrim) {
    charToTrim = charToTrim.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
    const regEx = new RegExp('^[' + charToTrim + ']+|[' + charToTrim + ']+$', 'g');
    return origString.replace(regEx, '');
  }
}
